import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInSeconds from 'date-fns/differenceInSeconds';

export function getTimeDifference(endDate: Date, startDate: Date) {
  const seconds = (differenceInSeconds(endDate, startDate) % 60).toString().padStart(2, '0');
  const minutes = (differenceInMinutes(endDate, startDate) % 60).toString().padStart(2, '0');
  const hours = differenceInHours(endDate, startDate).toString().padStart(2, '0');

  return {
    hours,
    minutes,
    seconds,
  };
}

export const calculateTimeInHours = ({
  time,
  format,
}: {
  time: number;
  format: 'string' | 'clock';
}) => {
  const hours = Math.floor(time / 60);
  const minutes = time % 60;

  return `${
    format === 'string'
      ? `${minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`}`
      : `${hours}:${minutes.toString().padStart(2, '0')}`
  }`;
};

//export const calculateTimeInHours = ({
//   time,
//   format = 'string',
// }: {
//   time: number;
//   format?: 'clock' | 'string';
// }) => {
//   const hours = Math.floor(time / 60);
//   const minutes = time % 60;
//   return `${hours}h ${minutes}m`;
// };
